export const decodeJWT = (token) => {
  if (!token) return null;

  try {
    const [, payload] = token.split(".");
    if (!payload) return null;

    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const paddedBase64 = base64.padEnd(
      base64.length + ((4 - (base64.length % 4)) % 4),
      "=",
    );

    const jsonPayload = atob(paddedBase64);

    const decoded = JSON.parse(jsonPayload);

    if (decoded.exp) {
      const now = Math.floor(Date.now() / 1000);
      if (decoded.exp <= now) return null;
    }

    return decoded;
  } catch (error) {
    console.error("Error decoding JWT:", error);
    return null;
  }
};
